import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=2161ad96&scoped=true&"
import script from "./contactForm.vue?vue&type=script&lang=js&"
export * from "./contactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161ad96",
  null
  
)

export default component.exports